import React from "react"
import { Helmet } from "react-helmet"

import './layoutStyle.css';
import { rhythm, scale } from "../../utils/typography"

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        position: 'absolute',
        top: 0,
        left: 0,
        bototm: 0,
        right: 0
      }}
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sunset Health</title>
        <link rel="canonical" href="http://https://saaya.sunset.health/" />
      </Helmet>
      <main>{children}</main>
    </div>
  )
}

export default Layout